import { createFeatureSelector, createSelector } from '@ngrx/store';

import { State, titleRepFeatureKey } from '../reducers/title-rep.reducer';

export const selectTitleRepFeature = createFeatureSelector<State>(titleRepFeatureKey);

export const selectContactInfo = createSelector(selectTitleRepFeature, (state: State) => ({
  company: state.company,
  email: state.email,
  firstName: state.firstName,
  lastName: state.lastName,
  phone: state.phone,
  phoneType: state.phoneType,
  photoUrl: state.photoUrl
}));

export const selectEmail = createSelector(selectTitleRepFeature, (state: State) => state.email);

export const selectOrderTitleCCEnabled = createSelector(
  selectTitleRepFeature,
  (state: State) => state.orderTitleCCEnabled
);
